import axios from './axios';

/**
 * calls an api to log current session
 */
const logSession = () => axios.post(`/user-session-log`);

export default logSession;
